import axios from 'axios';
import { API_MAP } from 'helpers/api';

export type ViaCepAddress = {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
  unidade: string;
  erro?: boolean;
};

class ViaCepNotFoundError extends Error {
  constructor() {
    super('CEP não encontrado');
    this.name = 'ViaCepNotFoundError';
  }
}

export const cleanZipcode = (zipcode: string) => {
  if (!zipcode) {
    return '';
  }

  return zipcode.replace(/\D/g, '').slice(0, 8);
};

export const isValidZipcode = (zipcode: string) => {
  return /^\d{8}$/.test(cleanZipcode(zipcode));
};

export async function getAddressByZipcode(zipcode: string): Promise<ViaCepAddress> {
  const cleanedZipcode = cleanZipcode(zipcode);
  const url = API_MAP.getAddressByZipCode.replace('{zip_code}', cleanedZipcode);
  const { data } = await axios.get<ViaCepAddress>(url, {
    headers: { 'Content-type': 'application/json' }
  });

  if (data.erro) {
    throw new ViaCepNotFoundError();
  }

  return data;
}
